import { ErrorCodes } from '../SharedApiExternalContract';
import { VersionNumber as VersionNumberContract } from '@tableau/api-internal-contract-js';

import { TableauError } from './TableauError';

/**
 * Represents the current version of the extensions library
 */
export class VersionNumber implements VersionNumberContract {
  // Using some webpack tricks, we can inject this version into our code (kinda like c++ preprocessor stuff)
  private static _instance: VersionNumber;

  /**
   * Gets the singleton instance of the version number.
   */
  public static get Instance(): VersionNumber {
    return VersionNumber._instance;
  }

  public static SetVersionNumber(numString: string): void {
    VersionNumber._instance = new VersionNumber(numString);
  }

  public readonly major: number;
  public readonly minor: number;
  public readonly fix: number;

  // private constructor so everyone uses the singleton instance
  private constructor(versionString: string) {
    const parts = versionString.split('.').map(p => parseInt(p, 10));
    if (parts.length !== 3) {
      throw new TableauError(ErrorCodes.InternalError, `Invalid version number: ${versionString}`);
    }

    this.major = parts[0];
    this.minor = parts[1];
    this.fix = parts[2];
  }

  public get formattedValue(): string {
    return `${this.major}.${this.minor}.${this.fix}`;
  }
}



// WEBPACK FOOTER //
// ../../../src/ApiShared/VersionNumber.ts


// WEBPACK FOOTER //
// webpack:///src/ApiShared/VersionNumber.ts